module.exports = __webpack_public_path__ + "img/zcxlj.fa4efcde.png";